import "./MenuList.scss";

import React from "react";

import { Row, Col, Button } from "react-bootstrap";
import MenuListSublist from "./MenuListSublist";
import { MenuItem } from "../../../../datatypes/MenuItem";
import MenuListUtil from "../../../../utils/MenuListUtil";

const ELEMENTS_PER_ROW = 6;

type Props = {
    topLevelMenuItem: MenuItem;
};

class MenuList extends React.Component<
    Props,
    {
        selectedTabIndex: number;
    }
> {
    constructor(props: Props) {
        super(props);
        this.state = {
            selectedTabIndex: 0
        };
    }

    renderColumn(chunk: Array<MenuItem>, index: number) {
        return (
            <Col sm={3} md={2} key={"col-" + index}>
                {(chunk ?? [])
                    .filter((e) => e !== undefined)
                    .map((item: MenuItem, index: number) => (
                        <MenuListSublist item={item} key={index} />
                    ))}
            </Col>
        );
    }

    selectCategoryTab(index: number) {
        this.setState({
            selectedTabIndex: index
        });
    }

    renderTabNavigation(categories: Array<MenuItem>) {
        if (!categories) {
            return null;
        }
        const selectedCategory = categories[this.state.selectedTabIndex];
        if (!selectedCategory) {
            return null;
        }

        const content = selectedCategory.children ? this.renderRows(selectedCategory.children) : null;

        return (
            <div>
                <div
                    className="hidden-xs clearfix category-tab-navigation"
                    onClick={(event) => {
                        event.stopPropagation();
                        return false;
                    }}>
                    <div className="pull-left">
                        {categories.map((c, index) => (
                            <Button
                                className={"category-tab" + (index === this.state.selectedTabIndex ? " selected" : "")}
                                onClick={() => this.selectCategoryTab(index)}
                                key={index}>
                                {c.name}
                            </Button>
                        ))}
                    </div>
                    <Row className="clearfix" />
                </div>
                {content}
            </div>
        );
    }

    renderRows(menuItems: Array<MenuItem>) {
        const chunkedMenuItems = MenuListUtil.distributeElementsEquallyIntoCols(menuItems, ELEMENTS_PER_ROW);
        return (
            <div className="category-list scrollable-menu">
                <Row>{chunkedMenuItems.map(this.renderColumn)}</Row>
            </div>
        );
    }

    render() {
        const topLevelMenuItems = this.props.topLevelMenuItem || {};
        if (topLevelMenuItems.tabNavigation && topLevelMenuItems.children) {
            return this.renderTabNavigation(topLevelMenuItems.children);
        }

        return topLevelMenuItems.children ? this.renderRows(topLevelMenuItems.children) : null;
    }
}

export default MenuList;
